import { Mapper } from "../../../../base/utils/mapper";
import { ProfilePhotoModel } from "../../../../domain/models/user/profile-photo.model";
import { ProfilePhotoEntity } from "../entities/profile-photo.entity";

export class ProfilePhotoImplementationRepositoryMapper extends Mapper<ProfilePhotoEntity, ProfilePhotoModel> {
    mapFrom(param: ProfilePhotoEntity): ProfilePhotoModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProfilePhotoModel): ProfilePhotoEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}
